import { DISPUTES } from '../actionTypes';

export const fetchDisputes = (action) => ({
  type: DISPUTES.FETCH,
  payload: action.payload,
});
